import styled from '@emotion/styled';
import { FC } from 'react';

import { SponsorCard } from '@/components/event/SponsorCard';
import { SectionTitle } from '@/components/reception/SectionTitle';
import { EventSponsor } from '@/resources/EventSponsor';
import { EventSponsorPackage } from '@/resources/EventSponsorPackage';
import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

const SponsorsContainer = styled.div<IThemeProps>`
  margin: 40px 0 80px;
`;

const ListContainer = styled.div<IThemeProps>`
  display: grid;
  grid-template-columns: repeat(auto-fit, 185px);
  grid-gap: 40px;
  column-gap: 40px;
  margin-top: 32px;

  img {
    height: 137px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    grid-template-columns: repeat(auto-fit, 205px);

    img {
      height: 148px;
    }
  }
`;

interface ISponsorPackageProps {
  eventSponsorPackage: EventSponsorPackage;
  eventSponsors?: Array<EventSponsor>;
}

export const SponsorPackage: FC<ISponsorPackageProps> = ({ eventSponsorPackage }) => {
  if (eventSponsorPackage.eventSponsors?.length === 0) {
    return null;
  }

  return (
    <SponsorsContainer>
      <SectionTitle>{`${eventSponsorPackage.name} `}</SectionTitle>
      <ListContainer>
        {eventSponsorPackage?.eventSponsors.map((sponsor) => {
          return <SponsorCard key={sponsor.id} eventSponsor={sponsor} />;
        })}
      </ListContainer>
    </SponsorsContainer>
  );
};
